import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";

export default function Games1() {
  return (
    <>
      <Navbar2 Page={""} />
      <div style={{ display: "flex", justifyContent: "center",padding:"10px 0" }}>
        
        <iframe
          style={{ maxWidth: "100%" }}
          src="https://wordwall.net/embed/569497658a3a479fb5087aa744abc3ae?themeId=1&templateId=46&fontStackId=0"
          width="500"
          height="380"
          frameborder="0"
          allowfullscreen
        ></iframe>

      </div>
      <Footer />
    </>
  );
}
